import { render, staticRenderFns } from "./UserSignUp.vue?vue&type=template&id=0239dd9a"
import script from "./UserSignUp.vue?vue&type=script&lang=js"
export * from "./UserSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports